import { render, staticRenderFns } from "./SaleLeads.update.vue?vue&type=template&id=5a565212"
import script from "./SaleLeads.update.vue?vue&type=script&lang=js"
export * from "./SaleLeads.update.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports